export const configuration = {
  minLength: 8,
  blockedWords: ['password', 'restore'],
  uppercaseRegex: /^[A-Z]$/,
  lowercaseRegex: /^[a-z]$/,
  numberRegex: /^[0-9]$/,
  symbolRegex: /^[-#!$@%^&*()_+|~=`{}[\]:";'<>?,./ ]$/,
  symbolList: '-#!$@%^&*()_+|~=`{}[]:";\'<>?,./ ',
};
